// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var DemographicSurveyAction = function (x) {
    return x;
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runDemographicSurveyAction = function (v) {
    return v;
};
var mkDemographicSurveyAction = DemographicSurveyAction;
var maybeToOption = function (maybeValue) {
    if (maybeValue instanceof Data_Maybe.Nothing) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    };
    if (maybeValue instanceof Data_Maybe.Just) {
        return Ouroboros_Services_Clients_Interop_Option.some(maybeValue.value0);
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DemographicSurvey (line 78, column 3 - line 80, column 36): " + [ maybeValue.constructor.name ]);
};
var toLoadingErrorInput = function (errorValue) {
    return Ouroboros_Models_Core_ErrorHandlers.paymentErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: maybeToOption(errorValue.statusCode)
    });
};
var handlePaymentSuccess = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runNavigate(env.navigate)(env.homeRoute)));
};
var handlePaymentError = function (loading) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var submitDemographicTask = function (env) {
    return function (survey) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handlePaymentError(env.loading))(function (v1) {
                return handlePaymentSuccess(env);
            })(env.paymentClient.submitDemographicInformation(env.promoCode)(survey));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var mkDemographicSurveyController = function (env) {
    return {
        submit: function (survey) {
            return mkDemographicSurveyAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitDemographicTask(env)(survey)));
        }
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/demographic_survey_controller.md";
export {
    DemographicSurveyAction,
    mkDemographicSurveyController,
    runDemographicSurveyAction,
    documentationPath
};
//# sourceMappingURL=index.js.map
